import axios from "axios";
//导入进度条插件
import NProgress from "nprogress";
//导入进度条样式
import "nprogress/nprogress.css";

import { getToken } from "@/utils/myAuth";

// Set config defaults when creating the instance
const requests = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
});

// 添加请求拦截器
requests.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    NProgress.start();
    if (config.method.toLowerCase() === "get") {
      config.params = config.params || config.data;
    }
    // 携带token
    config.headers["token"] = getToken();
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    NProgress.done();
    return Promise.reject(error);
  }
);

// 添加响应拦截器
requests.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    NProgress.done();
    // -- 如果服务端返回token无效，则要跳转至登录界面
    if (response.msg === "未登录" || response.msg === "登录已过期") {
      window.location =
        "/users/#/login?url=" +
        window.location.href;
    }

    return response.data;
  },
  function (error) {
    // 对响应错误做点什么
    NProgress.done();
    return Promise.reject(error);
  }
);

// --转换FormData
export function convertToFormData(obj) {
  const formData = new FormData();
  Object.keys(obj).forEach((key) => {
    formData.append(key, obj[key]);
  });
  return formData;
}

export default requests;
